module.exports = __webpack_public_path__ + "img/phone.150e447b.svg";